import { Injectable } from '@angular/core';
import { PaymentEngine } from './payment-engine';
import { PaymentEngineMX } from './payment-engine-mx';
import { PaymentEngineUS } from './payment-engine-us';
import { PaymentEngineGB } from './payment-engine-gb';
import { PaymentEnginePH } from './payment-engine-ph';
import { Store, select } from '@ngrx/store';
import * as fromCore from './../../core/reducers/index';
import * as fromPayments from './../store/reducers/index';
import { Subscription, Observable, zip, combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Customer } from './../../core/models/customer.model';
import { Company } from './../../core/models/company.model';
import { ParametersService } from './../../core/services/parameters.service';
import { BankService } from './bank.service';
import { AppConfigurationService } from './../../../cemexng2components/components/app-configuration';
import { PaymentEngineConfiguration } from './payment-engine-configuration';
import { PaymentConfigurationActions } from './../store/actions/payment-configuration.action';
import { PaymentService } from './payment.service';
import { PaymentEngineCO } from './payment-engine-co';
import { PaymentEngineDO } from './payment-engine-do';
import { PaymentProcessActions } from './../store/actions/payment-process.action';
import { TranslationService } from '@cemex-core/angular-localization-v7';
import { Router } from '@angular/router';
import { StorageManagerService } from '@app/core/services/storage-manager.service';

@Injectable()
export class PaymentEngineService {

    paymentEngine: PaymentEngine;
    selectedEngine: string;

    constructor(
        protected featureService: AppConfigurationService,
        protected parametersService: ParametersService,
        protected bankService: BankService,
        protected paymentService: PaymentService,
        protected store$: Store<fromCore.State>,
        protected t: TranslationService,
        protected r: Router,
        private storageManagerService: StorageManagerService
    ) { }

    initPaymentEngine(customer: Customer, company: Company): void {
        this.selectedEngine = customer.countryCode;

        const properties: Map<string, any> = new Map();
        properties.set('featureService', this.featureService);
        properties.set('parametersService', this.parametersService);
        properties.set('bankService', this.bankService);
        properties.set('paymentService', this.paymentService);
        properties.set('store$', this.store$);
        properties.set('customer', customer);
        properties.set('company', company);
        properties.set('t', this.t);
        properties.set('router', this.r);

        const configuration: PaymentEngineConfiguration = {
            initProperties: properties
        };
        switch (customer.countryCode) {
            case 'MX':
                this.paymentEngine = new PaymentEngineMX(configuration, this.t);
                break;
            case 'US':
                this.paymentEngine = new PaymentEngineUS(configuration, this.t);
                break;
            case 'CO':
                this.paymentEngine = new PaymentEngineCO(configuration, this.t, this.storageManagerService);
                break;
            case 'GB':
                this.paymentEngine = new PaymentEngineGB(configuration, this.t);
                break;
            case 'PH':
                this.paymentEngine = new PaymentEnginePH(configuration, this.t, this.r,  this.storageManagerService);
                break;
            case 'DO':
                this.paymentEngine = new PaymentEngineDO(configuration, this.t, this.storageManagerService);
                break;
        }

        this.store$.dispatch(new PaymentConfigurationActions.ClearPaymentConfiguration());
        this.store$.dispatch(new PaymentConfigurationActions.LoadPaymentConfiguration());
    }

}
